import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
const LoginSuccessRedirectPage = (props) => {
    const [state, setState] = useState({

    })
    const setLanguage = () => {
        if (props.token && props.token != "" && props.token != null) {
            if (["agent", "agent_staff"].includes(props.userCredentials.user_details.user_type)) {
                if (props.userCredentials?.user_details?.is_subscribed) {
                    props.history.push(`/${localStorage.getItem('i18nextLng')}/agent/agent_booking`);
                } else {
                    props.history.push(`/${localStorage.getItem('i18nextLng')}/agent/branch`);
                }
            } else {
                props.history.push(`/${localStorage.getItem('i18nextLng')}/home`);
            }
        } else {
            props.history.push('/en/login');
        }


    }
    useEffect(() => {
        setLanguage();
    }, [state.loginCredentials]);

    return (
        <></>
    );
}



const mapStateToProps = (globalState) => {
    return {
        token: globalState.LoginReducer.token,
        userCredentials: globalState.LoginReducer.userCredentials
    };
}

export default connect(mapStateToProps)(LoginSuccessRedirectPage);


